import Cart from '../../components/cart/cart.vue';

export default {
    path: '/cart',
    component: Cart,
    meta: {
        requiresAuth: true,
        hideFooter: true,
    }
};